

















































import { createComponent, ref } from "@vue/composition-api";
import { useRouting } from "@dcc/compositions/useRouting";
import {
  BaseMultiSelect,
  BaseMultiSelectItem,
  BaseLink,
  BasePrimaryButton
} from "@web-components";
import { findGetters } from "@dcc/store/drinking/getters";
import { getActions } from "@dcc/store/drinking/actions";
import { daysOfWeekText } from "@dcc/types/dayOfWeek";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
export default createComponent({
  components: {
    BaseMultiSelect,
    BaseMultiSelectItem,
    BaseLink,
    BasePrimaryButton
  },
  setup(props: {}, context) {
    const { handleNext, handlePrev } = useRouting(context);
    const dictionary = useDictionary();

    const { getWeeklyDrinkingDays } = findGetters(context.root.$store);
    const weeklyDays = ref(getWeeklyDrinkingDays().value);

    const { updateWeeklyDrinkingDays } = getActions(context.root.$store);

    const handleSelected = () => {
      updateWeeklyDrinkingDays(weeklyDays.value);
      handleNext();
    };

    return {
      weeklyDays,
      handleSelected,
      handlePrev,
      daysOfWeekText,
      ...dictionary
    };
  }
});
